export default __webpack_public_path__ + "static/media/JULYDOM2026.5eac13a4.png";